import { FETCH_STAFF } from '../../actionTypes/shared/apiActionTypes';
import { apiActionCreator } from '../../actionCreators';

const fetchStaff = (assessorIds, client) => async dispatch => {
    const additionalApiParams = {
        apiParams: [assessorIds],
    };
    await apiActionCreator(dispatch, FETCH_STAFF, client.getExternalStaff, additionalApiParams);
};

export default fetchStaff;
